<script setup lang="ts">
import { useToast } from '../composables/useToast';
import type { ToastType } from '../composables/useToast';

const { toasts, removeToast } = useToast();

const getTypeClasses = (type: ToastType) => {
  switch (type) {
    case 'success':
      return 'bg-green-500';
    case 'error':
      return 'bg-red-500';
    case 'info':
    default:
      return 'bg-blue-500';
  }
};
</script>

<template>
  <div class="fixed bottom-[calc(100%-var(--screen-height)+16px)] left-1/2 -translate-x-1/2 z-50 space-y-2 pointer-events-none max-w-[90vw]">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="bg-surface px-6 py-4 rounded-lg shadow-lg pointer-events-auto relative"
      >
        <!-- type dot -->
        <div 
          class="absolute -top-1 -left-1 w-2.5 h-2.5 rounded-full"
          :class="getTypeClasses(toast.type)"
        />
        
        <!-- close button -->
        <button
          @click="removeToast(toast.id)"
          class="absolute -top-2 -right-2 w-5 h-5 hover:bg-surface-hover rounded-full transition-all bg-surface shadow-md flex items-center justify-center hover:scale-110"
        >
          <svg 
            class="w-3 h-3" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2.5" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <!-- content -->
        <div class="space-y-1 mt-1">
          <div v-if="toast.title" class="font-medium text-sm">{{ toast.title }}</div>
          <div class="text-sm opacity-90">{{ toast.message }}</div>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translate(0, 100%);
}

.toast-move {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style> 